import React, { useEffect, useState } from 'react';
import useStyle from './topBar.style';
import { HeaderText } from '../../atoms/Texts/HeaderText';
import { IconButton } from '../../atoms/Buttons/IconButton';
import logout from '../../../graphql/logout';
import { NavBurgerList } from 'components/organisms/Menus/NavBurgerList';
import { ChallengeModal } from 'components/organisms/Challenge/ChallengeModal';
import { PublicShopModal } from '../../organisms/PublicShop/PublicShopModal';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from 'hooks/useMediaQuery';
import ClassNgoChoice from 'components/organisms/ClassNgoChoice';

type Emoji = {
  url: string;
  alt: string;
};

interface TopBarViewProps {
  reload: () => void;
  variant: 'default' | 'autumn' | 'spring';
  emoji: Emoji;
  hideLogOut: boolean;
  title: string;
  onDashboard: boolean;
  isPublicShop?: boolean;
  notifications: JSX.Element;
  goToPublicPanier?: () => void;
  goToPublicShopHome?: () => void;
}

export type TopBarStyleProps = {
  isTablet: boolean;
  isPublicShop: boolean;
  isDesktop: boolean;
};

export const TopBarView = ({
  reload,
  variant,
  emoji,
  hideLogOut,
  title,
  notifications,
  onDashboard,
  isPublicShop = false,
  goToPublicPanier,
  goToPublicShopHome
}: TopBarViewProps) => {
  const isMobile = useMediaQuery('mobile');
  const isTablet = useMediaQuery('tablet');
  const isDesktop = useMediaQuery('desktop');
  const classes = useStyle({ isTablet, isPublicShop, isDesktop });
  const location = useLocation();
  const [displayMenuMobile, setDisplayMenuMobile] = useState(false);

  useEffect(() => {
    setDisplayMenuMobile(false);
  }, [location]);

  return (
    <>
      {isPublicShop && (
        <div className={classes.root}>
          <PublicShopModal />
          <div className={classes.icons}>
            <div className={classes.mobileMenu}>
              <IconButton onClick={goToPublicPanier} icon={'ShoppingCart'} />
            </div>
            {!isTablet && <IconButton onClick={reload} icon={'Refresh'} />}
            <IconButton
              variant={isMobile ? 'publicShopButton' : 'elevate'}
              onClick={goToPublicShopHome}
              icon={'Pocket'}
            />
          </div>
        </div>
      )}
      {!isPublicShop && (
        <div className={classes.root}>
          <div className={classes.headerText}>
            <HeaderText
              text={title}
              isOnDashboardTitle={onDashboard}
              emoji={emoji}
            />
          </div>
          <div className={classes.rightCol}>
            <ChallengeModal variant={variant} />
            {notifications}
            <ClassNgoChoice />
            <div>
              <div className={classes.mobileMenu}>
                <IconButton onClick={reload} icon={'Refresh'} />
                <IconButton
                  onClick={() => setDisplayMenuMobile(!displayMenuMobile)}
                  icon={null}
                  isMenuBurger={true}
                />
              </div>
              <div className={classes.desktopMenu}>
                <IconButton onClick={reload} icon={'Refresh'} />
                {!hideLogOut && <IconButton onClick={logout} icon={'Logout'} />}
              </div>
            </div>
          </div>
        </div>
      )}
      {displayMenuMobile && <NavBurgerList />}
    </>
  );
};
